// Français pour le sélecteur #.
import { registerFr } from '../i18n/index.js';

registerFr({
  'Insert a reference': 'Insérer une référence',
}, 'RefSuggest');
